export const ROUTES_NAMES = {
  home: "/cloudsFeed", //first screen after login....or screen redirected in case of incorrect urls
  preloginPage:"/",
  login: "/login",
  register: "/register",
  app: "/cloud",
  cloudsFeed: "/cloudsFeed",
  articlesFeed: "/articles",
  chat: "/chat",
  bookmarkedArticles: "/bookmarkedArticles",
  bookmarkedClouds: "/bookmarkedClouds",
  blogsFeed: "/MyDiary",
  reportedClouds: "/reportedClouds",
  reportedArticles: "/reportedArticles",
};

// export default ROUTES_NAMES;

export const LOGGED_IN_DISALLOWED_ROUTES = [
  ROUTES_NAMES.login,
  ROUTES_NAMES.register,
  ROUTES_NAMES.preloginPage
];

export const LOGGED_IN_ALLOWED_ROUTES = [
  ROUTES_NAMES.app,
  ROUTES_NAMES.cloudsFeed,
  ROUTES_NAMES.articles,
  ROUTES_NAMES.chat,
  ROUTES_NAMES.bookmarkedClouds,
  ROUTES_NAMES.bookmarkedArticles,
  ROUTES_NAMES.reportedArticles,
  ROUTES_NAMES.reportedClouds,
  ROUTES_NAMES.blogsFeed,
];

export const ADMIN_ROUTES = [
  ROUTES_NAMES.reportedClouds,
  ROUTES_NAMES.reportedArticles,
]




// WEBPACK FOOTER //
// ./src/routes.js